import { CommonModule } from '@angular/common';
import { ErrorHandler, NgModule } from '@angular/core';
import { AppInsightsLogger } from './app-insights-logger';
import { ConsoleLogger } from './console-logger';
import { Logger } from './logger';
import { LoggingErrorHandler } from './logging-error-handler';
import { LOGGING_ADAPTERS, MultiLogger } from './multi-logger';
import { NgrxStoreLogger } from './ngrx-store-logger';
import { CacheLogger } from './cache-logger';
import { NewRelicLogger } from './new-relic-logger';

@NgModule({
  imports: [CommonModule],
  declarations: [],
  providers: [
    { provide: LOGGING_ADAPTERS, useClass: AppInsightsLogger, multi: true },
    { provide: LOGGING_ADAPTERS, useClass: NgrxStoreLogger, multi: true },
    { provide: LOGGING_ADAPTERS, useClass: ConsoleLogger, multi: true },
    { provide: LOGGING_ADAPTERS, useClass: CacheLogger, multi: true },
    { provide: LOGGING_ADAPTERS, useClass: NewRelicLogger, multi: true },
    { provide: Logger, useClass: MultiLogger },
    { provide: ErrorHandler, useClass: LoggingErrorHandler },
    AppInsightsLogger,
    NewRelicLogger,
    ConsoleLogger,
    CacheLogger,
  ],
})
export class TcsLoggingModule {}
